<template>
  <div style="margin-top: 10px">
    <div class="search-form">
      <el-input
        v-model="config.productName"
        placeholder="请输入产品名称"
        style="width: 200px"
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>

      <el-button
        type="primary"
        style="margin-left: 10px"
        @click="additem">新增商品</el-button>
    </div>
    <el-table
      v-loading="loading"
      border
      highlight-current-row
      :data="list"
      @current-change="handleCurrentRowChange">
      <el-table-column
        label=""
        width="50">
        <template slot-scope="{row}">
          <el-radio
            :value="current.productId"
            :label="row.productId">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        label="商品名称"
        min-width="200"
        prop="productName"> </el-table-column>
      <el-table-column
        label="企业名称"
        min-width="130"
        prop="vendorName">
      </el-table-column>
      <el-table-column
        v-if="!permission.LVL2"
        label="所属机构"
        prop="sgsName"
        min-width="160"
      ></el-table-column>
    </el-table>
    <el-pagination
      background
      style="text-align: center;"
      :current-page="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="totalNum"
      @current-change="handleCurrentChange">
    </el-pagination>
    <edit-modal
      ref="edit"
      :callback="fetchList" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import EditModal from '../../products/add-modal'
export default {
  name: 'ProductSelectTable',
  components: { EditModal },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      list: [],
      config: {
        pageNum: 1,
        pageSize: 10,
        productName: '',
        vendorId: null,
        vendorName: ''
      },
      totalNum: 0,
      current: {}
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  methods: {
    additem() {
      const { vendorId, vendorName } = this.config
      this.$refs.edit.init({ vendorId, vendorName })
    },
    reset() {
      this.list = []
      this.config.pageNum = 1
      this.config.productName = ''
      this.config.vendorId = null
      this.config.vendorName = ''
      this.current = {}
      this.totalNum = 0
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    handleCurrentRowChange(row) {
      this.current = row || {}
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('account/getproducts', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(row) {
      this.config.vendorId = row.vendorId
      this.config.vendorName = row.vendorName
      this.fetchList()
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
